module.exports = __webpack_public_path__ + "images/rankingEvents-rank-gain-b3a0235b.svg";